import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ISearchParameterChipData } from '../models/search-parameter-chip-data.interface';

@Component({
    selector: 'upsc-dw-rewardship-advanced-filter-chip',
    templateUrl: './dw-rewardship-advanced-filter-chip.component.html',
    styleUrls: ['./dw-rewardship-advanced-filter-chip.component.scss'],
})
export class DwRewardshipAdvancedFilterChipComponent {
    @Input() public data: ISearchParameterChipData;
    @Output() public parameterRemoved = new EventEmitter<ISearchParameterChipData>();
    @HostBinding('class') public hostClass = 'dw-rewardship-advanced-filter-chip';

    constructor() {
    }

    public removeParameter() {
        this.parameterRemoved.emit(this.data);
    }
}
